import { Profile } from '@zapier/shared-entities';

export default function shouldRouteToStandaloneZapManagement(state) {
  const currentProfile = Profile.selectors.all.currentProfile(state);

  return (
    Profile.selectors.isSwitchOn(
      'zap_management_next_opt-in',
      currentProfile
    ) &&
    !Profile.selectors.isSwitchOn('zap_management_next_opt-out', currentProfile)
  );
}
